import { MenuItem, TextField, Box } from "@mui/material";
import "./style.css";
import { useEffect, useState } from "react";

function CustomSelect({ placeholder = "", options = [], id = "", onChange = () => { }, value = "", name = "" }) {

    const [val, setVal] = useState(value);

    useEffect(() => {
        setVal(value);
    }, [value])

    return (
        <div className="custom-select-v2" id={id}>
            {placeholder && <h6>{placeholder}</h6>}
            <select name={name} onChange={(e) => {
                setVal(e.target.value);
                onChange(e);
            }} value={val}>
                {options.map((option, index) => (
                    <option key={index} value={option.value}>{option.label}</option>
                ))}
            </select>
        </div>
    );
}

export default CustomSelect;